module.exports = __webpack_public_path__ + "static/media/ironglycinate1.e15d966c.pdf";